import { Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { BroadcastNoteService } from '@core/service';
import { NoteSidebarData } from '@app/core/model';

@Component({
  selector: 'app-notes-broadcast-service',
  template: '',
  styleUrls: [],
  standalone: true,
})
export class BroadcastServiceComponent {

  @Input() set noteData(value: string) {
    var obj = JSON.parse(value);
    this.service.broadcastNotes(obj.type, obj.payload)
  }

  @Input() set noteCreated(value: string) {
    this.service.notifyNoteCreated();
  }

  @Output() closeSidebar = new EventEmitter<any>();
  @Output() noteSidebarDataChange = new EventEmitter<NoteSidebarData>();
  @Output() noteEditStateChange = new EventEmitter<any>();

  constructor(
    element: ElementRef,
    private service: BroadcastNoteService) {
    let webComponent = element.nativeElement;

    webComponent.service = service;

    service.getCloseSidebarSubject().subscribe(() => this.closeSidebar.emit());
    service.getNoteSidebarData().subscribe(data => this.noteSidebarDataChange.emit(data));
    service.noteEditState$.subscribe(state => this.noteEditStateChange.emit(state));
  }
}
